<div class="verify_modal" >
  <p-button
    class="close_modal"
    (click)="closeDialog()"
    icon="pi pi-times"
  ></p-button>

  <div class="modal_title">

  </div>

  <form [formGroup]="otpForm" (ngSubmit)="onSubmit()" class="form">
    <div class="form_grid gap_p">
      <div class="w_100">
        <p-inputotp
          formControlName="otp"
          class="form_field"
          [integerOnly]="true"
          size="large"
        ></p-inputotp>

        <p class="resend">
          <span *ngIf="otpTimer > 0; else resendBlock">
            00:{{ otpTimer.toString().padStart(2, '0') }}
          </span>
          <ng-template #resendBlock>
            <p-button (click)="resendOtp()" label="Resend" [link]="true"></p-button>
          </ng-template>
        </p>
      </div>
    </div>
    <div class="btn_flex mt_40">
      <p-button label="Submit" class="w_100" type="submit"></p-button>
    </div>
  </form>
</div>
